import { Component, OnInit } from '@angular/core';
import { Testimonial, TestimonialService } from "services/testimonial.service";
import { PlatformService } from "services/platform.service";

@Component({
	selector: 'ras-testimonial',
	templateUrl: './testimonial.component.html',
	styleUrls: ['./testimonial.component.sass']
})
export class TestimonialComponent implements OnInit {

	public testimonial: Testimonial;
	public testimonials: Testimonial[];
 	public current_frame = 0

	private interval: number = 5000
	private timer = null

	constructor(private testimonialService: TestimonialService, private platform: PlatformService) { }

	change(frame) {
		if (frame < 0) this.current_frame = this.testimonials.length - 1
		else if (frame > this.testimonials.length - 1) this.current_frame = 0
		else this.current_frame = frame

		if (this.timer) clearTimeout(this.timer)
		this.timer = setTimeout( () => this.change(this.current_frame + 1), this.interval)
	}

	ngOnDestroy() {
		if (this.timer) clearTimeout(this.timer)
	}

	ngOnInit() {

		this.testimonialService
		.getTestimonials()
		.then(value => {
			this.testimonials = value
			this.current_frame = Math.floor(Math.random() * value.length)
			if (this.platform.isBrowser) {
				this.timer = setTimeout(() => this.change(this.current_frame + 1), this.interval)
			}
		})

	}

}
